module.exports = __webpack_public_path__ + "media/images/weather/52_day-aa7eb9c2553c89487c1ace20d8c40247.png";